import React from 'react';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropType from 'prop-types';
import { v4 } from 'uuid';
import { StyledReactTooltip, StyledTextTooltip } from './styled';
const TextTooltip = _ref => {
  let {
    element,
    text,
    place
  } = _ref;
  const dataFor = v4();
  return /*#__PURE__*/React.createElement(StyledTextTooltip, {
    "data-for": dataFor,
    "data-tip": text
  }, element ? element : /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faInfoCircle,
    size: "1x"
  }), /*#__PURE__*/React.createElement(StyledReactTooltip, {
    id: dataFor,
    place: place,
    type: "dark",
    effect: "solid",
    multiline: true
  }));
};
TextTooltip.defaultProps = {
  place: 'bottom',
  multiline: true
};
TextTooltip.propTypes = {
  element: PropType.node,
  text: PropType.string.isRequired,
  place: PropType.oneOf(['left', 'top', 'right', 'bottom']),
  multiline: PropType.bool
};
export default TextTooltip;